module.exports = "/images/vendor/flag-icon-css/flags/4x3/um.svg?8754eddfe66cfeebda8977e08505dfdb";